var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Privacy Policy")]),_c('div',{staticClass:"text-left px-4",domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}})])}
var staticRenderFns = []

export { render, staticRenderFns }